<template>
  <PlotBasePanel :settings="settings">
    <div class="controls">
      <ScaleCombobox v-model="scaleX" :values="scaleX_Values" :title="'Скорость:'" :width="60" :unit="scaleX_Unit" />
      <ScaleCombobox v-model="scaleY" :values="scaleY_Values" :title="'Масштаб:'" :width="90" class="ml-5" :unit="scaleY_Unit" />
      <FiltersCombobox v-model="filters" :values="filters_Values" :title="'Фильтры:'" :width="160" class="ml-5" />
    </div>
  </PlotBasePanel>
</template>

<script>
import ScaleCombobox from "../core/scale-combobox";
import FiltersCombobox from "../core/filters-combobox";
import PlotBasePanel from "../core/plot-base-panel";

export default {
  name: "OnlineBasePlot",
  emits: ["scaleXChanged", "scaleYChanged", "filtersChanged"],
  components: {
    ScaleCombobox,
    FiltersCombobox,
    PlotBasePanel
  },

  props: {
    settings: Object
  },

  data: () => ({
    // Toolbar values
    scaleX: null,
    scaleY: null,
    filters: null,
    controlsPrepared: true // Для отмены создания событий во время инициализации значений тулбара (масштабы фильтры и т.д.)
  }),
  computed: {
    scaleX_Values() {
      return this.settings.scaleX.values;
    },
    scaleY_Values() {
      return this.settings.scaleY.values;
    },
    scaleX_Unit() {
      return this.settings.scaleX.unit;
    },
    scaleY_Unit() {
      return this.settings.scaleY.unit;
    },
    filters_Values() {
      return this.settings.filters.allowed;
    }
  },
  watch: {
    scaleX(val) {
      !this.isEqual(this.settings.scaleX.current, val) && this.$emit("scaleXChanged", val);
    },
    scaleY(val) {
      !this.isEqual(this.settings.scaleY.current, val) && this.$emit("scaleYChanged", val);
    },
    filters(val) {
      !this.isEqual(this.settings.filters.current, val) && this.$emit("filtersChanged", val);
    },
    settings() {
      this.extractToolbarSettings();
    }
  },

  methods: {
    extractToolbarSettings() {
      const { scaleX, scaleY, filters } = this.settings;
      this.controlsPrepared = false;
      this.scaleX = scaleX.current;
      this.scaleY = scaleY.current;
      this.filters = filters.current;
      this.controlsPrepared = true;
    },
    isEqual(obj1, obj2) {
      return obj1 === obj2 || JSON.stringify(obj1) === JSON.stringify(obj2);
    }
  },

  mounted() {
    this.extractToolbarSettings();
  }
};
</script>
